@if (!!filters) {
  <op-query-filters (filtersChanged)="filters = $event"
  [filters]="filters" />
}
